export default __webpack_public_path__ + "de9c967725e65d8060150a904cfdc087.svg";